import styles from './BrandHeaderSkeleton.module.scss';

const BrandHeaderSkeleton = () => {
  return (
    <div className={styles.root}>
      <div className={styles.skeleton}>
        <div className={styles.header}>
          <div className={styles.skeletonHeaderLogo}></div>
          <div className={styles.searchContainer}>
            <div className={styles.searchWrapper}>
              <input
                type="text"
                placeholder="Search menu items"
                className={styles.searchInput}
                disabled
              />
            </div>
          </div>
        </div>
        <div className={styles.skeletonContent}>
          <div className={styles.skeletonLogo}></div>
          <div className={styles.skeletonDetails}>
            <div className={styles.skeletonTitle}></div>
            <div className={styles.skeletonSubtitle}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandHeaderSkeleton;
